<template>
    <div class="n2-center-container" style="background-color:#fff; padding:10px;">
        <div class="n2-padding n2-text-center">
            <div v-if="code == 'booking_failed'">
                <h5>{{ $t('pages.failed.complete_order_failed_title') }}</h5>
                <div class="">{{ $t('pages.failed.complete_order_failed_desc') }}</div>
            </div>
            <div v-if="code == 'already_processed'">
                <h5>{{ $t('pages.failed.already_processed_title') }}</h5>
                <div class="">{{ $t('pages.failed.already_processed_desc') }}</div>
            </div>
            <div v-if="code == 'payment_failed'">
                <h5 class="n2-text-center">{{ $t('pages.failed.payment_failed_title') }}</h5>
                <div class="n2-text-center">{{ $t('pages.failed.payment_failed_desc') }}</div>
                <div class="n2-text-center n2-margin-top">
                    <button class="n2-button-1"
                        v-on:click="restartPay">{{ $t('pages.failed.button_restart_payment') }}</button>
                </div>
            </div>
            <div v-if="code == 'reservation_failed'">
                <h5 class="n2-text-center">{{ $t('pages.failed.reservation_failed_title') }}</h5>
                <div class="n2-text-center">{{ $t('pages.failed.reservation_failed_desc') }}</div>
                <div class="n2-text-center n2-margin-top">
                    <button class="n2-button-1"
                        v-on:click="newTripSearch">{{ $t('pages.failed.button_search_trip') }}</button>
                </div>
            </div>
            <div v-if="code == 'booking_time_passed'">
                <h5 class="n2-text-center">{{ $t('pages.failed.booking_time_passed_title') }}</h5>
                <div class="n2-text-center">{{ $t('pages.failed.booking_time_passed_desc') }}</div>
                <div class="n2-text-center n2-margin-top">
                    <button class="n2-button-1"
                        v-on:click="newTripSearch">{{ $t('pages.failed.button_search_trip') }}</button>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import { mapGetters } from 'vuex';


export default {
    components: {
    },
    data: function () {
        return {
            code: ''
        }
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
            'locale'
        ])
    },
    created: function () {
    },
    mounted: async function () {
        const { code } = this.$route.params
        this.code = code
    },
    methods: {
        restartPay: function () {
            this.$router.push({ path: `/${this.app_locale}/checkout?previous_step=payment_error` })
        },
        newTripSearch:function(){
            this.$router.push({ path: `/${this.app_locale}` })
        }
    }
}
</script>
